var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1312 50.1982V42.7869C22.1312 40.9019 23.668 39.3702 25.5721 39.3575H32.5468C34.4599 39.3575 36.0109 40.8929 36.0109 42.7869V42.7869V50.2212C36.0104 51.8217 37.3008 53.1298 38.917 53.1673H43.5668C48.202 53.1673 51.9596 49.4473 51.9596 44.8584V44.8584V23.7754C51.9349 21.9702 51.0787 20.2749 49.6347 19.1721L33.7325 6.49013C30.9466 4.28194 26.9863 4.28194 24.2004 6.49013L8.36786 19.1952C6.91843 20.2935 6.06082 21.9915 6.04297 23.7984V44.8584C6.04297 49.4473 9.80058 53.1673 14.4358 53.1673H19.0856C20.742 53.1673 22.0847 51.838 22.0847 50.1982V50.1982",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelected);
export default __webpack_public_path__ + "static/media/DashboardSelected.1e7815828018aa7899f48a6f6e1f0b6e.svg";
export { ForwardRef as ReactComponent };